import React, {useState, useEffect} from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const localFilterModel = { items:[...filterModel.items, {field:"status", operator:"equals", value:"accepted"}]}
        setLocalFilterModel(localFilterModel);
        setLocalDrawable(true);
    },[filterModel])

    const { getComparableTimeframe } = useDates();

    return (localDrawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Accettate"
                dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                filters={localFilterModel}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Maturato Acquisto"
                dataProviderName={'statisticsviews/item/sumfinancial/opportunities/proposal/buyerCommissionValue'}
                filters={localFilterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'full'}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            
        </Box>
    )
}

export default KPISet;
